import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MiscService } from 'app/shared/misc.service';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { NotificationsService } from '../notifications.service';
import * as notificationsActions from './notifications.actions'

@Injectable({
    providedIn: 'root'
})

export class NotificationsEffects {
    constructor(
        private actions$: Actions,
        private notificationsService: NotificationsService,
        private toastr: ToastrService,
        private miscService: MiscService
    ) {}

    fetchAllNotifications$ = createEffect(() =>
    this.actions$.pipe(
      ofType(notificationsActions.fetchNotifications),
      exhaustMap((action) =>
        this.notificationsService
          .getAllNotifications()
          .pipe(
            exhaustMap((response: any) => [
                notificationsActions.fetchNotificationsSuccess({ notifications: response.data }),
            ]),
            catchError((error: HttpErrorResponse) => {
                this.toastr.error(error.error?.errors, 'An error occured');
                return of(notificationsActions.fetchNotificationsFailed())
            }
            )
          )
      )
    )
  );

    createNotification$ = createEffect(() =>
    this.actions$.pipe(
      ofType(notificationsActions.createNotification),
      exhaustMap((action) =>
        this.notificationsService
          .sendNotification(action.notificationDto)
          .pipe(
            exhaustMap((response: any) => [
                notificationsActions.createNotificationSuccess(),
            ]),
            catchError((error: HttpErrorResponse) => {
                this.toastr.error(error.error?.errors, 'An error occured');
                return of(notificationsActions.createNotificationFailed())
            }
            )
          )
      )
    )
  );


    deleteNotification$ = createEffect(() =>
    this.actions$.pipe(
      ofType(notificationsActions.deleteNotification),
      exhaustMap((action) =>
        this.notificationsService
          .deleteNotification(action.notificationId)
          .pipe(
            exhaustMap((response: any) => [
                notificationsActions.deleteNotificationSuccess(),
            ]),
            catchError((error: HttpErrorResponse) => {
                this.toastr.error(error.error?.errors, 'An error occured');
                return of(notificationsActions.deleteNotificationFailed())
            }
            )
          )
      )
    )
  );


    uploadFile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(notificationsActions.uploadFile),
      exhaustMap((action) =>
        this.notificationsService
          .uploadFile(action.file)
          .pipe(
            exhaustMap((response: any) => [
                notificationsActions.uploadFileSuccess(),
            ]),
            catchError((error: HttpErrorResponse) => {
                this.toastr.error(error.error?.errors, 'An error occured');
                return of(notificationsActions.uploadFileFailed())
            }
            )
          )
      )
    )
  );


}